import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkAxiosRequest } from 'shared/api';
import {
	Person,
	PersonFields,
	PersonParams,
	PersonResponse,
	UpdatePersonParams,
} from './types';

export const getPersons = createAsyncThunk<PersonResponse, PersonParams>(
	'getPersons',
	async (params, { rejectWithValue }) => {
		const search = params.search;
		if (search && search.includes('+7') && search.length <= 5) {
			return;
		}

		return await thunkAxiosRequest({
			path: `/api/v1/persons`,
			params,
			rejectWithValue,
		});
	},
	{
		getPendingMeta: params => params,
	},
);

export const getPersonsBookList = createAsyncThunk<
	PersonResponse,
	PersonParams
>(
	'getPersonsBookList',
	async (params, { rejectWithValue }) => {
		return await thunkAxiosRequest({
			path: `/api/v1/persons`,
			params,
			rejectWithValue,
		});
	},
	{
		getPendingMeta: params => params,
	},
);

export const getPerson = createAsyncThunk<
	Person,
	{ id: number; isDefaultPerson?: boolean }
>(
	'getPerson',
	async (params, { rejectWithValue }) => {
		return await thunkAxiosRequest({
			path: `/api/v1/persons/${params.id}`,
			rejectWithValue,
		});
	},
	{
		getPendingMeta: params => params,
	},
);

export const updatePerson = createAsyncThunk<Person, UpdatePersonParams>(
	'updatePerson',
	async (params, { rejectWithValue }) => {
		return await thunkAxiosRequest({
			path: `/api/v1/persons/${params.id}`,
			params: params.body,
			method: 'patch',
			rejectWithValue,
		});
	},
);

export const createPerson = createAsyncThunk<Person, PersonFields>(
	'createPerson',
	async (params, { rejectWithValue }) => {
		return await thunkAxiosRequest({
			path: `/api/v1/persons`,
			params: params,
			method: 'post',
			rejectWithValue,
		});
	},
);
